export const countries = {
    Andorra: 'Andorra',
    'الإمارات العربيّة المتّحدة': 'United Arab Emirates',
    افغانستان: 'Afghanistan',
    'Antigua and Barbuda': 'Antigua and Barbuda',
    Anguilla: 'Anguilla',
    Shqipëria: 'Albania',
    Հայաստան: 'Armenia',
    Angola: 'Angola',
    Antarctica: 'Antarctica',
    Argentina: 'Argentina',
    'Amerika Samoa': 'American Samoa',
    Österreich: 'Austria',
    Australia: 'Australia',
    Aruba: 'Aruba',
    Azərbaycan: 'Azerbaijan',
    'BiH/БиХ': 'Bosnia and Herzegovina',
    Barbados: 'Barbados',
    বাংলাদেশ: 'Bangladesh',
    Belgique: 'Belgium',
    Burkina: 'Burkina Faso',
    Bulgaria: 'Bulgaria',
    البحري: 'Bahrain',
    Burundi: 'Burundi',
    Bénin: 'Benin',
    Bermuda: 'Bermuda',
    دارالسلام: 'Brunei',
    Bolivia: 'Bolivia',
    Brasil: 'Brazil',
    'The Bahamas': 'The Bahamas',
    'Druk-Yul': 'Bhutan',
    Bouvetøya: 'Bouvet Island',
    Botswana: 'Botswana',
    Беларусь: 'Belarus',
    Belize: 'Belize',
    Canada: 'Canada',
    'Cocos (Keeling) Islands': 'Cocos (Keeling) Islands',
    Congo: 'Congo',
    'République centrafricaine': 'Central African Republic',
    'Congo-Brazzaville': 'Congo-Brazzaville',
    Schweiz: 'Switzerland',
    'Côte d’Ivoire': 'Côte d’Ivoire',
    'Cook Islands': 'Cook Islands',
    Chile: 'Chile',
    Cameroun: 'Cameroon',
    中国: 'China',
    Colombia: 'Colombia',
    'Costa Rica': 'Costa Rica',
    Cuba: 'Cuba',
    'Cabo Verde': 'Cape Verde',
    'Christmas Island': 'Christmas Island',
    'Κύπρος / Kıbrıs': 'Cyprus',
    Česko: 'Czech Republic',
    Deutschland: 'Germany',
    'جيبوتي /Djibouti': 'Djibouti',
    Danmark: 'Denmark',
    Dominica: 'Dominica',
    'República Dominicana': 'Dominican Republic',
    الجزائ: 'Algeria',
    Ecuador: 'Ecuador',
    Eesti: 'Estonia',
    مصر: 'Egypt',
    'الصحراء الغربي': 'Western Sahara',
    ኤርትራ: 'Eritrea',
    España: 'Spain',
    ኢትዮጵያ: 'Ethiopia',
    Suomi: 'Finland',
    'Fiji / Viti': 'Fiji',
    'Falkland Islands': 'Falkland Islands',
    Micronesia: 'Micronesia',
    'Føroyar / Færøerne': 'Faroes',
    France: 'France',
    Gabon: 'Gabon',
    'United Kingdom': 'United Kingdom',
    Grenada: 'Grenada',
    საქართველო: 'Georgia',
    'Guyane française': 'French Guiana',
    Ghana: 'Ghana',
    Gibraltar: 'Gibraltar',
    Grønland: 'Greenland',
    Gambia: 'Gambia',
    Guinée: 'Guinea',
    Guadeloupe: 'Guadeloupe',
    'Guinea Ecuatorial': 'Equatorial Guinea',
    Ελλάδα: 'Greece',
    'South Georgia and the South Sandwich Islands': 'South Georgia and the South Sandwich Islands',
    Guatemala: 'Guatemala',
    Guåhån: 'Guam',
    'Guiné-Bissau': 'Guinea-Bissau',
    Guyana: 'Guyana',
    香港: 'Hong Kong SAR of China',
    Honduras: 'Honduras',
    Hrvatska: 'Croatia',
    Ayiti: 'Haiti',
    Magyarország: 'Hungary',
    Indonesia: 'Indonesia',
    Éire: 'Ireland',
    ישראל: 'Israel',
    India: 'India',
    'British Indian Ocean Territory': 'British Indian Ocean Territory',
    'العراق / عيَراق': 'Iraq',
    ايران: 'Iran',
    Ísland: 'Iceland',
    Italia: 'Italy',
    Jamaica: 'Jamaica',
    أردنّ: 'Jordan',
    日本: 'Japan',
    Kenya: 'Kenya',
    Кыргызстан: 'Kyrgyzstan',
    Kâmpŭchea: 'Cambodia',
    Kiribati: 'Kiribati',
    'اتحاد القمر': 'Comoros',
    'Saint Kitts and Nevis': 'Saint Kitts and Nevis',
    북조선: 'North Korea',
    한국: 'South Korea',
    الكويت: 'Kuwait',
    'Cayman Islands': 'Cayman Islands',
    'Қазақстан /Казахстан': 'Kazakhstan',
    ເມືອງລາວ: 'Laos',
    لبنان: 'Lebanon',
    'Saint Lucia': 'Saint Lucia',
    Liechtenstein: 'Liechtenstein',
    'ශ්‍රී ලංකා / இலங்கை': 'Sri Lanka',
    Liberia: 'Liberia',
    Lesotho: 'Lesotho',
    Lietuva: 'Lithuania',
    Luxemburg: 'Luxembourg',
    Latvija: 'Latvia',
    '‏ليبيا‎': 'Libya',
    المغربية: 'Morocco',
    Monaco: 'Monaco',
    Moldova: 'Moldova',
    Madagascar: 'Madagascar',
    'Marshall Islands': 'Marshall Islands',
    'Северна Македонија': 'North Macedonia',
    Mali: 'Mali',
    Myanmar: 'Myanmar',
    'Монгол Улс': 'Mongolia',
    '澳門 / Macau': 'Macao SAR of China',
    'Northern Marianas': 'Northern Marianas',
    Martinique: 'Martinique',
    الموريتانية: 'Mauritania',
    Montserrat: 'Montserrat',
    Malta: 'Malta',
    Mauritius: 'Mauritius',
    ޖުމުހޫރިއްޔ: 'Maldives',
    Malawi: 'Malawi',
    México: 'Mexico',
    مليسيا: 'Malaysia',
    Moçambique: 'Mozambique',
    Namibia: 'Namibia',
    'Nouvelle-Calédonie': 'New Caledonia',
    Niger: 'Niger',
    'Norfolk Island': 'Norfolk Island',
    Nigeria: 'Nigeria',
    Nicaragua: 'Nicaragua',
    Nederland: 'Netherlands',
    Norge: 'Norway',
    नेपाल: 'Nepal',
    Naoero: 'Nauru',
    Niue: 'Niue',
    'New Zealand / Aotearoa': 'New Zealand',
    عُمان: 'Oman',
    Panamá: 'Panama',
    Perú: 'Peru',
    'Polynésie française': 'French Polynesia',
    'Papua New Guinea  / Papua Niugini': 'Papua New Guinea',
    Philippines: 'Philippines',
    پاکستان: 'Pakistan',
    Polska: 'Poland',
    'Saint-Pierre-et-Miquelon': 'Saint Pierre and Miquelon',
    'Pitcairn Islands': 'Pitcairn Islands',
    'Puerto Rico': 'Puerto Rico',
    Portugal: 'Portugal',
    'Belau / Palau': 'Palau',
    Paraguay: 'Paraguay',
    قطر: 'Qatar',
    Réunion: 'Reunion',
    România: 'Romania',
    Росси́я: 'Russia',
    Rwanda: 'Rwanda',
    السعودية: 'Saudi Arabia',
    'Solomon Islands': 'Solomon Islands',
    Seychelles: 'Seychelles',
    السودان: 'Sudan',
    Sverige: 'Sweden',
    Singapore: 'Singapore',
    'Saint Helena, Ascension and Tristan da Cunha': 'Saint Helena, Ascension and Tristan da Cunha',
    Slovenija: 'Slovenia',
    Svalbard: 'Svalbard',
    Slovensko: 'Slovakia',
    'Sierra Leone': 'Sierra Leone',
    'San Marino': 'San Marino',
    Sénégal: 'Senegal',
    Soomaaliya: 'Somalia',
    Suriname: 'Suriname',
    'São Tomé e Príncipe': 'São Tomé e Príncipe',
    'El Salvador': 'El Salvador',
    سوري: 'Syria',
    eSwatini: 'Eswatini',
    'Turks and Caicos Islands': 'Turks and Caicos Islands',
    'تشاد / Tchad': 'Chad',
    'Terres australes françaises': 'French Southern Territories',
    Togo: 'Togo',
    ไทย: 'Thailand',
    Тоҷикистон: 'Tajikistan',
    Tokelau: 'Tokelau',
    Türkmenistan: 'Turkmenistan',
    التونسية: 'Tunisia',
    Tonga: 'Tonga',
    "Timor Lorosa'e": 'Timor-Leste',
    Türkiye: 'Türkiye',
    'Trinidad and Tobago': 'Trinidad and Tobago',
    Tuvalu: 'Tuvalu',
    中華: 'Taiwan',
    Tanzania: 'Tanzania',
    Україна: 'Ukraine',
    Uganda: 'Uganda',
    'United States Minor Outlying Islands': 'United States Minor Outlying Islands',
    'United States': 'United States',
    Uruguay: 'Uruguay',
    'O‘zbekiston': 'Uzbekistan',
    Vaticano: 'Vatican City',
    'Saint Vincent and the Grenadines': 'Saint Vincent and the Grenadines',
    Venezuela: 'Venezuela',
    'British Virgin Islands': 'British Virgin Islands',
    'US Virgin Islands': 'US Virgin Islands',
    'Việt Nam': 'Vietnam',
    Vanuatu: 'Vanuatu',
    'Wallis and Futuna': 'Wallis and Futuna',
    Samoa: 'Samoa',
    اليمنية: 'Yemen',
    Mayotte: 'Mayotte',
    'Afrika-Borwa': 'South Africa',
    Zambia: 'Zambia',
    Zimbabwe: 'Zimbabwe',
    فلسطين: 'Palestine',
    Åland: 'Åland',
    'Heard Island and McDonald Islands': 'Heard Island and McDonald Islands',
    'Crna Gora': 'Montenegro',
    Srbija: 'Serbia',
    Jersey: 'Jersey',
    Guernsey: 'Guernsey',
    'Mann / Mannin': 'Isle of Man',
    'Saint-Martin': 'Saint Martin',
    'Saint-Barthélemy': 'Saint Barthélemy',
    'Bonaire, Sint Eustatius en Saba': 'Bonaire, Sint Eustatius and Saba',
    Curaçao: 'Curaçao',
    'Sint Maarten': 'Sint Maarten',
    'South Sudan': 'South Sudan',
    Kosovo: 'Kosovo',
};
